import React, { useEffect } from 'react';
import { useHistory, useParams } from 'react-router';
import { route } from '~/app/helpers/route';
import usePageTitle from '~/app/hooks/usePageTitle';
import { useAppHeader } from '~/app/modules/appHeader';
import { useStoreActions, useStoreState } from '~/store';
import { MACHINES_DETAILS_ROUTES } from '~/machines/Details/Router';
import Training from './Training';
import { Training as TrainingType } from '../types';

export type DetailComponent = React.FC

const Detail: DetailComponent = () => {

    const { id } = useParams<{ id: TrainingType['id'] }>();

    const netWorkStatus = useStoreState(state => state.app.offline.status);
    const machine = useStoreState(state => state.machine.data);
    const trainingDetail = useStoreState(state => state.training.data);

    const fetchTraining = useStoreActions(actions => actions.training.fetchTraining);

    const history = useHistory();
    const { setData } = useAppHeader();

    usePageTitle(trainingDetail.title);

    useEffect(() => {
        setData({
            title: trainingDetail.title,
            subTitle: (machine.intern + " - " + machine.name).toUpperCase(),
            backLink: history.length > 1 ? history.goBack : route(MACHINES_DETAILS_ROUTES.listTraining, { id }),
            showUser: false,
            machineId: '',
            projectId: '',
            showMachineMessages: false,
            isIssueDetailPage: false,
            notification: false,
            search: false
        });
    }, [setData, trainingDetail.title, history, id, machine.intern, machine.name]);

    useEffect(() => {
        netWorkStatus === 0 && fetchTraining(id);
    }, [netWorkStatus, fetchTraining, id]);

    return (
        <Training training={trainingDetail} />
    );
}

export default Detail
